module.exports = __webpack_public_path__ + "d08fc5009993edcc81b9cd6c541276e7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-pink.png
// module id = 1830
// module chunks = 0